export const GUIDELINE_CITATION_BADGE_LABELS = {
  LOADING: 'Loading guideline citation…',
  UNAVAILABLE: 'Citation unavailable',
};
